import * as React from 'react';
import accounting from 'accounting';
import CheckoutCardPrintable from '../CheckoutCardPrintable';
import confirmationImage from 'src/assets/checkoutConfirmed';
import './ConfirmationCard.scss';

import ItemModel from 'src/model/cartItem.model';
import UserModel from 'src/model/user.model';
import LocationModel from 'src/model/location.model';
import { IShippingMethod } from 'src/services/checkout/CheckoutService';
import CreditCardModel from 'src/model/creditCard.model';
import Checkout from 'src/components/Checkout/Checkout';
import * as ReactDOMServer from 'react-dom/server';
import { env } from 'src/shared/env';

interface IConfirmationCardProps {
  confirmationNumber: number;
  items: { [key: number]: ItemModel };
  userData: UserModel;
  deliverMethod: string;
  orderConfirmed: boolean;
  deliveryLocation: LocationModel;
  termsOfDelivery: string;
  PONumber: string;
  shippingMethod: IShippingMethod;
  paymentMethod: string;
  selectedCreditCard: CreditCardModel;
  emailConfirmation: boolean;
  subtotal: string;
  taxTotal: string;
  total: string;
  t?: any;
  downloadPdf?: (orderData: string) => void;
  isDownloadingPdf?: boolean;
  
}

class ConfirmationCard extends React.Component<IConfirmationCardProps, any> {
  public state = {
    showPrintWindow: false
  };
  private renderPrintOrder = () => {
    this.setState({ showPrintWindow: true });
  };

  private closePrintWindow = () => {
    this.setState({ showPrintWindow: false });
  };


  private downloadOrder = () => {
    const parsedData = ReactDOMServer.renderToString(this.getOrderDetails());
    this.props.downloadPdf(parsedData);
  };

  private getOrderDetails = () => {
    const { t } = this.props;    
    return (
      <div>
        <div className="address" style={{ fontFamily: 'Times New Roman' }}>
          <div style={{ float: 'right' }}>
            <p>
              {this.props.confirmationNumber
                ? `Confirmation #${this.props.confirmationNumber}`
                : ''}
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontWeight: 'bold',
              margin: '130px 0 30px 0'
            }}
          >
            {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
              <React.Fragment>
                <span>Reliable Parts</span>
                <br />
                <span>85 North Bend St</span>
                <br />
                <span>Coquitlam, BC V3K 6N1</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>Reliable Parts</span>
                <br />
                <span>P.O. Box 566268</span>
                <br />
                <span>Dallas, Texas 75356</span>
              </React.Fragment>
            )}
          </div>
          {`Account: #${this.props.userData.accountId}`}
          <p
            style={{
              fontWeight: 'bold',
              margin: '0px 0 16px 0'
            }}
          >
            {t('checkoutPage.accountInfo')}
          </p>
          <div style={{ margin: '0 0 32px 0' }}>{this.renderAccountInfo()}</div>
          <p style={{ fontWeight: 'bold', margin: '0px 0 16px 0' }}>
            {t('checkoutPage.shippingInfo')}
          </p>
          <div style={{ margin: '0 0 32px 0' }}>
            {this.renderShippingInfo()}
          </div>
          <p style={{ fontWeight: 'bold', margin: '0px 0 16px 0' }}>
            {t('checkoutPage.paymentMethod')}
          </p>
          <div>{this.renderPaymentMethod()}</div>
        </div>
        <div style={{ margin: '24px 0 16px 0' }}>
          <div style={{ margin: '0 0 32px 0' }}>{this.renderItemsOrder()}</div>
        </div>
      </div>
    );
  };

  private renderItemsOrder = () => {
    const { t } = this.props;
    return (
      <table
          style={{
            borderCollapse: 'collapse',
            tableLayout: 'fixed',
            width: '700px'
          }}
        >
        <thead>
          <tr style={{ fontWeight: 'bold' }}>
            <td
              style={{
                padding: '0 8px',
                textTransform: 'capitalize',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '15%'
              }}
            >
              {'Your Item'}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '8%'
              }}
            >
              {t('myOrders.qty')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '15%'
              }}
            >
              {'Shipment'}<br/>{'Marking'}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '15%'
              }}
            >
              {'Warranty'}<br/>{'Provider'}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '15%'
              }}
            >
              {t('myFavourites.dispatch')}/<br/>{t('product.claims_plural')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '15%'
              }}
            >
              {'Shipping'}<br/>{'From'}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '8%'
              }}
            >
              {'Unit'}<br/>{'Price'}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '9%'
              }}
            >
              {'Item'}<br/>{'Total'}
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(this.props.items).map((item, index) => {
            const product = this.props.items[item];
            return (
              <tr key={index}
                style={{
                  wordWrap : 'break-word' 
                  }}
                >
                <td
                  style={{
                    padding: '0 8px',
                    textTransform: 'capitalize',
                    textAlign: 'left'
                  }}
                >
                  {product.name}
                </td>
                <td
                  style={{
                    padding: '0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.quantity}
                </td>
                <td
                  style={{
                    padding: '0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.shipmentMarking}
                </td>
                <td
                  style={{
                    padding: '0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.warrantyProvider}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.claims}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.shipsfrom.name}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.unitPrice}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.itemTotal}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  private renderPaymentMethod = () => {
    const { t } = this.props;
    return (
      <table>
        <thead>
          <tr style={{ fontWeight: 'bold' }}>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>{''}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {this.props.paymentMethod === '001'
                ? `${t('checkoutPage.paidByAccount')}: #${
                    this.props.userData.accountId
                  }`
                : this.props.paymentMethod === '002' ||
                  this.props.paymentMethod === '004'
                ? this.props.selectedCreditCard
                  ? `${this.props.selectedCreditCard.type}: **** **** **** ${this.props.selectedCreditCard.number}`
                  : `${t('checkoutPage.paidByCreditCard')}`
                : this.props.paymentMethod === '003'
                ? 'Paid by Credit E-Check:'
                : null}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  private renderShippingInfo = () => {
    const { t } = this.props;
    return (
      <div>
        <table>
          <thead>
            <tr style={{ fontWeight: 'bold' }}>
              <td style={{ padding: '0 8px', textAlign: 'left' }}>
                {t('checkoutPage.shippingTo')}
              </td>
              <td style={{ padding: '0 8px', textAlign: 'left' }}>
                {t('checkoutPage.shippingFrom')}
              </td>
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                this.props.deliverMethod !== 'Pick-Up' ? (
                  <td style={{ padding: '0 8px', textAlign: 'left' }}>
                    {t('checkoutPage.shippingMethod')}
                  </td>
                ) : (
                  ''
                )
              ) : (
                <td style={{ padding: '0 8px', textAlign: 'left' }}>
                  {t('checkoutPage.shippingMethod')}
                </td>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  padding: '0 8px',
                  textAlign: 'left',
                  textTransform: 'capitalize'
                }}
              >
                {this.props.deliveryLocation &&
                this.props.deliveryLocation.name !== ''
                  ? this.props.deliveryLocation.name
                  : 'N/A'}
              </td>
              <td
                style={{
                  padding: '0 8px',
                  textAlign: 'left',
                  textTransform: 'capitalize'
                }}
              >
                {this.getShipFrom()}
              </td>
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                this.props.deliverMethod !== 'Pick-Up' ? (
                  <td style={{ padding: '0 8px', textAlign: 'left' }}>
                    {this.props.shippingMethod.motdescription}
                  </td>
                ) : (
                  ''
                )
              ) : (
                <td style={{ padding: '0 8px', textAlign: 'left' }}>
                  {this.props.shippingMethod.motdescription}
                </td>
              )}
            </tr>
            <tr>
              <td
                style={{
                  padding: '0 8px',
                  textAlign: 'left',
                  textTransform: 'capitalize'
                }}
              >
                {this.props.deliveryLocation
                  ? `${
                      this.props.deliveryLocation.addressLine1
                        ? `${this.props.deliveryLocation.addressLine1.toLocaleLowerCase()}, `
                        : ''
                    }${
                      this.props.deliveryLocation.addressLine2
                        ? `${this.props.deliveryLocation.addressLine2.toLocaleLowerCase()}, `
                        : ''
                    }${
                      this.props.deliveryLocation.addressLine4
                        ? `${this.props.deliveryLocation.addressLine4.toLocaleLowerCase()}, `
                        : ''
                    }${
                      this.props.deliveryLocation.stateCode
                        ? `${this.props.deliveryLocation.stateCode} `
                        : ''
                    }${
                      this.props.deliveryLocation.postalCode
                        ? `${this.props.deliveryLocation.postalCode}`
                        : ''
                    }`
                  : 'N/A'}
              </td>
            </tr>
          </tbody>
        </table>
        <table style={{ margin: '32px 0px' }}>
          <thead>
            <tr style={{ fontWeight: 'bold' }}>
              <td style={{ padding: '0 8px', textAlign: 'left' }}>
                {t('myReturns.pONumber')}
              </td>
            </tr>
          </thead>
          <tbody>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {this.props.PONumber}
            </td>
          </tbody>
        </table>
      </div>
    );
  };

  private formatPhoneNumber = (value:any) => {
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) { 
      return phoneNumber; 
    }
    if (phoneNumberLength < 7) {
      return `+1(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `+1(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  private getShipFrom = () => {
    const { t } = this.props;
    let currentState: string = '';
    let times: number = 0;
    for (const key in this.props.items) {
      if (this.props.items.hasOwnProperty(key)) {
        const state = `${
          this.props.items[key].shipsfrom.addressLine4
            ? `${this.props.items[
                key
              ].shipsfrom.addressLine4.toLocaleLowerCase()}, `
            : ''
        }${
          this.props.items[key].shipsfrom.stateCode
            ? `${this.props.items[key].shipsfrom.stateCode.toUpperCase()}`
            : ''
        }`;
        if (times === 0) {
          currentState = state;
        }
        if (state && state !== currentState) {
          return 'Different Locations';
        }
        times++;
      }
    }
    return currentState ? currentState : `${t('checkoutPage.noInfoAvailable')}`;
  };

  private renderAccountInfo = () => {
    const { name, mobileNumber, email } = this.props.userData;
    const { t } = this.props;
    return (
      <table>
        <thead>
          <tr style={{ fontWeight: 'bold' }}>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {t('common.name')}{' '}
            </td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {t('common.email')}
            </td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {t('common.phone')}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>{name}</td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>{localStorage.getItem("orderEmail")?localStorage.getItem("orderEmail"):email}</td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {localStorage.getItem("orderPhone")?this.formatPhoneNumber(localStorage.getItem("orderPhone")):this.formatPhoneNumber(mobileNumber)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  public render() {

    {Object.keys(this.props.items).map((item, index) => {
      const product = this.props.items[item];
    })};

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.    
    const Gdata:any=[];
    {Object.keys(this.props.items).map((item, index) => {
      const product = this.props.items[item];
      Gdata.push({
        item_id:product.id,
        affiliation: "",
        item_name:product.name,
        manufacturer:product.manufacturerCode,
        description:product.description,
        coupon: "",
        discount: "",
        index: 0,
        item_brand: "",
        item_category: "",
        location_id:"",
        price:product.unitPrice,
        quantity:product.quantity,
        Item_Total_Price:product.itemTotal}); 
    }); 

  }
    // const GfinalData = JSON.stringify(Gdata);
    console.log("Product-Data", Gdata);
    window.dataLayer.push({
    event: "purchase",
    ecommerce: {
        transaction_id: this.props.confirmationNumber,
        value: this.props.total,
        tax: this.props.taxTotal,
        shipping: "",
        currency: "USD",
        coupon: "",
        items: Gdata
    }
});
    const { t } = this.props;
    return (
      <div className="rp-confirmation-card">
        <div className="rp-confirmation-card--top-bar" />
        <div className="rp-confirmation-card--info-area">
          <div className="rp-confirmation-card--info-area-message">
            <div>
              <div
                className="image"
                style={{
                  backgroundImage: `url(${confirmationImage})`
                }}
              />
            </div>
            <div className="rp-confirmation-card--info-area-message--text">
              <p className="rp-confirmation-card--info-area-message--text-title">
                {t('checkoutPage.orderCompleted')}
              </p>
              <p className="rp-confirmation-card--info-area-message--text-all">
                {this.props.emailConfirmation
                  ? `${t('checkoutPage.thanksForPurchaseWithEmail')}`
                  : `${t('checkoutPage.thanksForPurchase')}`}
              </p>
            </div>
          </div>
          <div className="rp-confirmation-card--info-area-confirmation">
            <div className="rp-confirmation-card--info-area-confirmation--number">
              {t('checkoutPage.confirmation')}{' '}
              <span>#{this.props.confirmationNumber}</span>
            </div>
            <div className="rp-confirmation-card--info-area-confirmation--link">
              <span className="rpds-print" />
              <div className="text" onClick={() => this.renderPrintOrder()}>
                {t('checkoutPage.printOrder')}
              </div>
            </div>
            <div className="rp-confirmation-card--info-area-confirmation--link">
              {this.props.isDownloadingPdf ? (
                <div className="text" style={{ opacity: '0.6' }}>
                  Download Order
                </div>
              ) : (
                <div className="text" onClick={() => this.downloadOrder()}>
                  Download Order
                </div>
              )}
            </div>
          </div>
        </div>
        {this.state.showPrintWindow && (
          <CheckoutCardPrintable
            items={this.props.items}
            closeWindow={this.closePrintWindow}
            userData={this.props.userData}
            deliverMethod={this.props.deliverMethod}
            orderConfirmed={this.props.orderConfirmed}
            deliveryLocation={this.props.deliveryLocation}
            termsOfDelivery={this.props.termsOfDelivery}
            PONumber={this.props.PONumber}
            shippingMethod={this.props.shippingMethod}
            paymentMethod={this.props.paymentMethod}
            selectedCreditCard={this.props.selectedCreditCard}
            confirmationNumber={this.props.confirmationNumber}
          />
        )}
      </div>
    );
  }
}

export default ConfirmationCard;
